import React from "react";
import "./Homeworks.css";
import {
  FaMobileAlt,
  FaBoxOpen,
  FaIndustry,
  FaCheckCircle,
  FaTruck
} from "react-icons/fa";

const steps = [
  {
    icon: <FaMobileAlt />,
    title: "Order on the App",
    desc: "Tap. Select. Done. Your pickup is booked in seconds.",
  },
  {
    icon: <FaBoxOpen />,
    title: "Prepare Your Items",
    desc: "Gather your garments. We bring the bags. You just hand them over.",
  },
  {
    icon: <FaIndustry />,
    title: "World-Class Facility",
    desc: "Next-day delivery available. Cleaned, pressed, and at your door — on time, every time.",
  },
  {
    icon: <FaCheckCircle />,
    title: "Quality Checked & Packed",
    desc: "Every piece inspected before it leaves us — creases, colour, fasteners, finish. Sealed and packed to standard.",
  },
  {
    icon: <FaTruck />,
    title: "Back Tomorrow",
    desc: "Next-day delivery available. Cleaned, pressed, and at your door — on time, every time.",
  },
];

export default function HowItWorks() {
  return (
    <div className="how-container">

   <div className="how-header">
  <h2 className="how-title">
    Your Laundry Our Process Perfected
  </h2>

  <p className="how-subtitle">
    Premium laundry made effortless.
  </p>
</div>

      <div className="timeline">
        {steps.map((step, index) => {
          const position = index % 2 === 0 ? "left" : "right";

          return (
            <div className={`timeline-item ${position}`} key={index}>
              
              <div className="timeline-icon">
                {step.icon}
              </div>

              <div className="timeline-content">
                <span className="step-number">0{index + 1}</span>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>

            </div>
          );
        })}
      </div>

    </div>
  );
}